import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

// Callback to handle session expiration (set by AuthContext)
let onSessionExpired = null;
export const setSessionExpiredHandler = (callback) => {
  onSessionExpired = callback;
};

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("orello_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

// Handle unauthorized responses (401/403) - show modal instead of silently redirecting
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 || error.response?.status === 403) {
      // Token is invalid or expired - notify via callback
      if (onSessionExpired) {
        onSessionExpired();
      } else {
        // Fallback: redirect to login if no handler set
        localStorage.removeItem("orello_token");
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiError(detail, fallback = "Something went wrong. Try again.") {
  if (detail == null) return fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return fallback;
}
